import React from 'react';
import { NavDropdown } from 'react-bootstrap';

const NavbarExportMenu = ({ onExportISLR, onExportIVA }) => {
    return (
        <NavDropdown
            title={<span><i className="bi bi-download me-2"></i>Exportar</span>}
            id="export-nav-dropdown"
            className="d-flex align-items-center"
        >
            <NavDropdown.Item onClick={onExportISLR}>
                <i className="bi bi-filetype-xml me-2 text-primary"></i>
                Retenciones ISLR (XML)
            </NavDropdown.Item>
            <NavDropdown.Item onClick={onExportIVA}>
                <i className="bi bi-file-text me-2 text-success"></i>
                Retenciones IVA (TXT)
            </NavDropdown.Item>
        </NavDropdown>
    );
};

export default NavbarExportMenu;
